import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductService } from '../services/product.service';

@Pipe({
  name: 'product'
})
export class ProductPipe implements PipeTransform {

  constructor(private _productService: ProductService){ }

  transform(value: number): Observable<string> {
    if(typeof value !== 'number') return of(null);
    return this._productService.getProductById(value).pipe(map(x => [x.productnumber, x.productservice].filter(x => x).join(' ')));
  }

}
